.app-brand {
  height: 100%;
}
